import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addDays, format, subYears } from "date-fns";
import { useFetchWrapper as Api } from "../../utils";
import { createTimezoneNameMap } from "../../utils/helper";
import { formatInTimeZone } from "date-fns-tz";
import { SELECTED_TIME_ZONE } from "../../components/constants/constants";
import { TRANSACTION } from "../../components/constants/api-paths";
import { HTTP_STATUS } from "../../components/constants";
import DasSnackbar from "../../components/das-snackbar/DasSnackbar";
import i18next from "i18next";
import i18n from "../../i18n";
import { HASH_CARD_ALLOWED_GROUPS } from "pages/hash-card/constants/hashcard";



const timezoneNameMap = createTimezoneNameMap();

// createAsyncThunk
export const downloadTransactionReportApi: any = createAsyncThunk(
  "transaction/TransactionsDateDownload",
  async (values: any) => {

    const downloadUrlApiPath = TRANSACTION.DOWNLOAD_URL_API;
    const downloadUrl = `${downloadUrlApiPath}?jobID=${values.JobID}`;
    const result = await Api().get(downloadUrl);
    const downloadedFile = await fetch(result.data.url).then((response: any) => {
      if (response.ok) {
        return response.blob();
      }
    });
    if (downloadedFile) {
      const a = document.createElement("a");
      if ([HTTP_STATUS.OK].includes(result?.statusCode)) {
        DasSnackbar.success(i18next.t("API_STATUS_MESSAGE.INFO_FS_O1000"));
      }
      const downloadUrl = window.URL.createObjectURL(downloadedFile);
      a.href = downloadUrl;

      /*if(result?.data?.fileName !== null && result?.data?.fileName !== undefined) {
        a.download = result?.data?.fileName;
      }
      else {
        const createdAt = getformatDate(
          values.CreatedAt,
          DATE_TIME_FORMAT_REPORT,
          values?.TimeZone
        ).toUpperCase().replace(/ /g, '_');

        console.log("-${createdAt}", createdAt);

        const fileName = `Transaction-Details-${createdAt}`;

        a.download = fileName.replace(/ /g, '-');
      }*/

      a.download = result?.data?.fileName;
      a.click();
      return result;
    }
  } 
);
export const getDownloadTransactionReportListApi: any = createAsyncThunk(
  "transaction/TransactionsDateDownload",
  async (payload: any, { dispatch }) => {
    let timeZone = localStorage.getItem(SELECTED_TIME_ZONE);

    const displayTimezone = timezoneNameMap.get(timeZone);
    const requestPayload = {
      ...payload,
      filter: Array.isArray(payload?.filter) ? [...payload.filter] : [],
      DisplayTimeZone: displayTimezone,
    };

    //StartDate need this format 2026/05/20 00:00:00
    if (
      !requestPayload.filter.find((item: any) => item.field === "DateStart") ||
      !requestPayload.filter.find((item: any) => item.field === "DateEnd")
    ) {
      const startDate = addDays(subYears(new Date(), 1), 1);
      requestPayload.filter.push({
        field: 'DateStart',
        operator: 'eq',
        value: format(startDate, 'yyyy-MM-dd') + ' 00:00:00',
      });

      requestPayload.filter.push({
        field: 'DateEnd',
        operator: 'eq',
        value: formatInTimeZone(new Date(), timeZone || 'Asia/Kolkata', 'yyyy-MM-dd HH:mm:ss'),
        operand: 'AND'
      });
    }

    //const state:any= getState();
    //const selectedFormatType = state?.config?.listViewConfiguration?.transactionListView?.formatType;
    const apiPath = `${TRANSACTION.REPORT_DOWNLOAD_API}?take=${10}&skip=${0}&TimeZone=${timeZone}`;
    const downloadReportApiPath = TRANSACTION.REQUEST_DOWNLOAD_API;
    let resp = await Api().post(downloadReportApiPath,requestPayload
      // `${downloadReportApiPath}?${value.filter}&TimeZone=${timeZone}&DownloadFormat=${value.selectedFormatType}&SelectedList=${value.selectedListType}&IncludeSensitiveColumns=${value.includeSensitiveColumns}`
    );
    if ([HTTP_STATUS.OK].includes(resp?.statusCode)) {
      DasSnackbar.success(i18n.t(`API_STATUS_MESSAGE.${resp?.messageCode}`));
    }
    dispatch(getDownloadTransactionReportList(apiPath));
    return resp.data;
  }
);
export const getDownloadTransactionReportList: any = createAsyncThunk(
  "transaction/getDownloadTransactionReportList",
async (apiPath) => {
    let data = await Api().get(apiPath);

    return data;
  }
);
export const getTransactionTable: any = createAsyncThunk(
  "transaction/getTransactionTable",
  async (apiPath) => {
    let data = await Api().get(apiPath);
    return data;
  }
);
export const getScheduleReportTable: any = createAsyncThunk(
  "transaction/getScheduleReportTable",
  async (apiPath:any) => {
    let data = await Api().get(apiPath);
    return data;
  }
);
// export const fetchTransactionFilterColumns: any = createAsyncThunk(
//   "transaction/fetchTransactionFilterColumns",
//  async ({apiPath}:any) => {
//     let data = await Api().get(apiPath);
//     return data;
//   },
// );
// Done purposefully for hashcard filter access in filter to different user 
export const fetchTransactionFilterColumns: any = createAsyncThunk(
  "transaction/fetchTransactionFilterColumns",
  async ({ apiPath }: any, { getState }) => {
    const response = await Api().get(apiPath);

    const columns = response?.data || [];

    // get auth groups from redux store
    const state: any = getState();
    const groups: string[] = state?.auth?.profile?.Groups || [];
    const isSignedInAsMerchant: boolean = state?.auth?.signedInAsMerchant === true;
    const hasHashCardAccess = groups.some(group =>
      HASH_CARD_ALLOWED_GROUPS.includes(group)
    );

    // determine if user is a customer (merchant) based on groups
    const isCustomerUser = groups.includes('CUSTOMER');

    const filteredColumns = columns.filter((col: any) => {
      // For customer/merchant users, use merchant-facing filter flag
      if (isCustomerUser || isSignedInAsMerchant) {
        return col.ShowInFilterMerchant === true;
      }

      // For internal users, use internal-facing filter flag
      if (col.ColumnName === "Hash_Card") {
        // keep Hash_Card condition as-is inside internal filter path
        return hasHashCardAccess && col.ShowInFilterInternal === true;
      }

      return col.ShowInFilterInternal === true;
    });

    return {
      ...response,
      data: filteredColumns,
    };
  }
);

export const fetchPresetFilterList: any = createAsyncThunk(
  "transaction/fetchPresetFilterList",
 async ({apiPath}:any) => {
    let data = await Api().get(apiPath);
    return data;
  },
);

export const postTransactionTable: any = createAsyncThunk(
  "transaction/postTransactionTable",
  async (props:any) => {
    const {apiPath,payload} = props;
    try {
      const data = await Api().post(apiPath,payload);
      return data;
    } catch (error) {
      console.log("err",error);
    }
  }
);


export const fetchTransactionStats: any = createAsyncThunk(
  "transaction/fetchTransactionStats",
  async (payload:any) => {
  const {apiPath,body} = payload;
    try {
      const response = await Api().post(apiPath, body);
      return response;
    } catch (error) {
      console.error('Error fetching transaction stats:', error);
    }
  }
);

export const fetchTransactionReportColumns: any = createAsyncThunk(
  "transaction/fetchTransactionReportColumns",
 async ({apiPath}:any) => {
    let data = await Api().get(apiPath);
    return data;
  },
);
export const fetchTransactionReportColumnsList: any = createAsyncThunk(
  "transaction/fetchTransactionReportColumnsList",
 async ({apiPath}:any) => {
    let data = await Api().get(apiPath);
    return data;
  },
);

export const fetchTransactionsColumnsList: any = createAsyncThunk(
  "transaction/fetchTransactionsColumnsList",
 async ({apiPath}:any) => {
    let data = await Api().get(apiPath);
    return data;
  },
);
// createSlice
export const transactionTableSlice = createSlice({
  name: "transactionTable",
  initialState: {
    transactionTable: [],
    count: 0,
    loading: false,
    transactionTableLoading: false,
    transactionFilterColumsLoading: false,
    transactionScheduleReportLoading: false,
    transactionReportColumsLoading: false,
    transactionReportColumsListLoading: false,
    transactionsColumsListLoading:false,
    error: null,
    downloadTransactionReportList: [],
    reportListCount: 0,
    scheduleListCount: 0,
    reportListApprovalRatio: 0,
    reportListDeclineCount: 0,
    reportListTotalSales: 0,
    reportListTotalRefund: 0,
    reportListStatsCurrency: 0,
    downloadListLoading: false,
    transactionState:{
      totalSales: 0,
      totalRefund: 0,
      approvalRatio: 0,
      currency: ""
    },
    transactionFilterColumns: [],
    transactionPresetFilters: [],
    transactionReportColumns: [],
    transactionReportColumnsList: [],
    transactionScheduleReportList: [],
    transactionPresetFiltersLoading: false,
    transactionsColumsList:[],
    transactionPresetFields: {selectedList:"", selectedListName:""},
    shouldRefreshTransactions: false,
  },
  reducers: {
    addNewRow: (state: any, { payload }) => {
      state.transactionTable = [payload, ...state.transactionTable];
    },
    setTransactionColumnList: (state: any, { payload }) => {
      state.transactionReportColumnsList = [payload, ...state.transactionReportColumnsList];
    },
    setTransactionPresetFields: (state: any, { payload }) => {
      state.transactionPresetFields = payload;
    },
    triggerTransactionRefresh: (state: any) => {
      state.shouldRefreshTransactions = true;
    },
    resetTransactionRefresh: (state: any) => {
      state.shouldRefreshTransactions = false;
    },
    resetTransactionTableState: (state: any) => {
    state.transactionsColumsList = [];
    state.transactionFilterColumns = [];
    state.transactionReportColumnsList = [];
    state.transactionPresetFilters = [];
    state.transactionTable = [];
    state.count = 0;
  }
  },
  extraReducers: (builder) => {
    builder.addCase(getTransactionTable.pending, (state) => {
      state.transactionTableLoading = true;
    });
    builder.addCase(getTransactionTable.fulfilled, (state, action) => {
      state.transactionTable = action?.payload?.data?.records;
      state.count = action?.payload?.data?.total_count;
      state.transactionTableLoading = false;
    });
    builder.addCase(getTransactionTable.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.transactionTableLoading = false;
    });

     builder.addCase(fetchTransactionFilterColumns.pending, (state) => {
      state.transactionFilterColumsLoading = true;
    });
    builder.addCase(fetchTransactionFilterColumns.fulfilled, (state, action) => {
      state.transactionFilterColumns = action?.payload?.data;
      state.transactionFilterColumsLoading = false;
    });
    builder.addCase(fetchTransactionFilterColumns.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.transactionFilterColumsLoading = false;
    });

     builder.addCase(getScheduleReportTable.pending, (state) => {
      state.transactionScheduleReportLoading = true;
    });
    builder.addCase(getScheduleReportTable.fulfilled, (state, action) => {
      state.transactionScheduleReportList = action?.payload?.data?.records;
      state.scheduleListCount = action?.payload?.data?.total_count;
      state.transactionScheduleReportLoading = false;
    });
    builder.addCase(getScheduleReportTable.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.transactionScheduleReportLoading = false;
    });


     builder.addCase(fetchTransactionReportColumns.pending, (state) => {
      state.transactionReportColumsLoading = true;
    });
    builder.addCase(fetchTransactionReportColumns.fulfilled, (state, action) => {
      state.transactionReportColumns = action?.payload?.data;
      state.transactionReportColumsLoading = false;
    });
    builder.addCase(fetchTransactionReportColumns.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.transactionReportColumsLoading = false;
    });

     builder.addCase(fetchTransactionReportColumnsList.pending, (state) => {
      state.transactionReportColumsListLoading = true;
    });
    builder.addCase(fetchTransactionReportColumnsList.fulfilled, (state, action) => {
      state.transactionReportColumnsList = action?.payload?.data;
      state.transactionReportColumsListLoading = false;
    });
    builder.addCase(fetchTransactionReportColumnsList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.transactionReportColumsListLoading = false;
    });


     builder.addCase(fetchPresetFilterList.pending, (state) => {
      state.transactionPresetFiltersLoading = true;
    });
    builder.addCase(fetchPresetFilterList.fulfilled, (state, action) => {
      state.transactionPresetFilters = action?.payload?.data;
      state.transactionPresetFiltersLoading = false;
    });
    builder.addCase(fetchPresetFilterList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.transactionPresetFiltersLoading = false;
    });

    builder.addCase(postTransactionTable.pending, (state) => {
      state.transactionTableLoading = true;
      
    });
    builder.addCase(postTransactionTable.fulfilled, (state, action) => {
      if(action?.payload?.data?.records && action?.payload?.data?.records.length > 0) {
        state.transactionTable = JSON.parse(action?.payload?.data?.records);
      }
      else {
        state.transactionTable = [];
      }
      state.count = action?.payload?.data?.total_count;
      state.reportListApprovalRatio = action?.payload?.data?.approval_ratio;
      state.reportListDeclineCount = action?.payload?.data?.decline_count;
      state.reportListTotalRefund = action?.payload?.data?.total_refund;
      state.reportListTotalSales = action?.payload?.data?.total_sales;
      state.reportListStatsCurrency = action?.payload?.data?.currency;
      state.transactionTableLoading = false;
    });
    builder.addCase(postTransactionTable.rejected, (state, action) => {
      state.error = action.payload;
      state.transactionTableLoading = false;
    });
    builder.addCase(getDownloadTransactionReportList.pending, (state) => {
      state.downloadListLoading = true;
    });
    builder.addCase(getDownloadTransactionReportList.fulfilled, (state, action) => {
      state.downloadTransactionReportList = action?.payload?.data?.records;
      state.reportListCount = action?.payload?.data?.total_count;
      state.downloadListLoading = false;
    });

    builder.addCase(getDownloadTransactionReportList.rejected, (state, action) => {
      state.error = action.payload;
      state.downloadListLoading = false;
    });

    builder.addCase(fetchTransactionStats.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTransactionStats.fulfilled, (state, action) => {
      state.loading = false;
      state.transactionState = {
        totalSales: action?.payload?.data?.TransactionTotalSales || 0,
        totalRefund: action?.payload?.data?.TransactionTotalRefund || 0,
        approvalRatio: action?.payload?.data?.TransactionApprovalRatio || 0,
        currency: action?.payload?.data?.Currency,
      };
    });
    builder.addCase(fetchTransactionStats.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(fetchTransactionsColumnsList.pending, (state) => {
                  state.transactionsColumsListLoading = true;
                });
                builder.addCase(fetchTransactionsColumnsList.fulfilled, (state, action) => {
                  state.transactionsColumsList = action?.payload?.data?.records;
                  state.transactionsColumsListLoading = false;
                });
                builder.addCase(fetchTransactionsColumnsList.rejected, (state, action) => {
                  state.loading = false;
                  state.error = action.payload;
                  state.transactionsColumsListLoading = false;
                });
  },
});

export const { addNewRow } = transactionTableSlice.actions;
export const { setTransactionColumnList } = transactionTableSlice.actions;
export const { setTransactionPresetFields } = transactionTableSlice.actions;
export const { triggerTransactionRefresh } = transactionTableSlice.actions;
export const { resetTransactionRefresh } = transactionTableSlice.actions;
export const { resetTransactionTableState } = transactionTableSlice.actions;
export const loadingTransactionStats = (state: any) => state?.transactionTable?.loading;
export const loadingTransactionRows = (state: any) =>
  state?.transactionTable?.transactionTableLoading;
export const loadingTransactionFilterColumns = (state: any) =>
  state?.transactionFilterColumns?.transactionFilterColumsLoading;
export const loadingScheduleReportList = (state: any) =>
  state?.transactionScheduleReportList?.transactionScheduleReportLoading;
export const loadingTransactionReportColumns = (state: any) =>
  state?.transactionReportColumns?.transactionReportColumsLoading;
export const loadingTransactionReportColumnsList = (state: any) =>
  state?.transactionReportColumnsList?.transactionReportColumsListLoading;
export const loadingPresetFiltersList = (state: any) =>
  state?.transactionPresetFilters?.transactionPresetFiltersLoading;
export const downloadListLoading = (state: any) => state?.transactionTable?.downloadListLoading;
export const rowsCount = (state: any) => state?.transactionTable?.count;
export const presetFields = (state: any) => state?.transactionTable?.transactionPresetFields;
export const loadingTransactionsColumnList = (state: any) =>
  state?.transactionsColumsList?.transactionsColumsListLoading;
export default transactionTableSlice.reducer;
